// extracted by mini-css-extract-plugin
module.exports = {"container":"AttachedList_container__3ctfR","content":"AttachedList_content__18EcB","header":"AttachedList_header__2bzAh","list":"AttachedList_list__39DEP"};